import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()


export const getSuccessStory = (abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.get("/SuccessStories", config);
  }

  export const createSuccessStory  =(data ,abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.post(`/SuccessStories`, data, config)
}

export const updateSuccessStory  =(id, data,abortToken )=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };    return api.put(`/SuccessStories/${id}`, data, config)
}

export const deleteSuccessStory  =(id,abortToken)=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };    return api.delete(`/SuccessStories/${id}`, config)
}